import { CoverageCalculatorOptions } from "@redotech/redo-model/coverage-calculator/index";
import { WidgetAutocheck } from "@redotech/redo-model/widget";

export function autocheckToCoverageSettings(
  autocheck: WidgetAutocheck,
): CoverageCalculatorOptions {
  return {
    pricePerOrder: autocheck.pricePerOrder,
    settings: {
      enabled: autocheck.enabled,
      coverageEnabled: autocheck.coverageEnabled,
      paidModel: autocheck.paidModel,

      // Coverage exclusions

      // customer is handled with "disableRedoForCustomer" field
      coverageExcludeCustomerTags: [],
      coverageExcludeCentEnding: [], // this is only implemented for commentsold currently
      coverageExcludeDiscountCodes:
        autocheck.coverageExcludeDiscountCodes || [],
      coverageExcludeProperties: autocheck.coverageExcludeProperties || [],
      coverageExcludeCollections: autocheck.coverageExcludeCollections || [],
      coverageExcludeProductTags: autocheck.finalSaleTags || [],
      excludeCoverageIfAnyInvalidProduct:
        autocheck.excludeCoverageIfAnyInvalidProduct,
      discountCodePartialMatch: autocheck.discountCodePartialMatch,
      protectionExcludeTags: autocheck.protectionExcludeTags,

      // Country settings
      countries: autocheck.countries || [],

      // Returns specific settings
      returns: {
        enabled: autocheck.enabled && autocheck.coverageEnabled,
        dynamicPricing: autocheck.dynamicReturnsPricing,
        internationalPricing: autocheck.internationalReturnsPricing,
        finalSaleReturns: autocheck.finalSaleReturns
          ? {
              ...autocheck.finalSaleReturns,
              enabled: autocheck.finalSaleReturns.coverageEnabled,
              validProductTags:
                autocheck.finalSaleReturns.coverageValidTags || [],
              validCollectionTitles:
                autocheck.finalSaleReturns.coverageValidCollectionTitles || [],
              pricingRuleSet: autocheck.finalSaleReturns.pricingRuleSets,
              minPrice: autocheck.finalSaleReturns.minPrice || 0,
            }
          : undefined,
      },

      // Package protection settings
      packageProtection: autocheck.packageProtection
        ? {
            ...autocheck.packageProtection,
            enabled: autocheck.packageProtection.coverageEnabled,
            coverage: autocheck.packageProtection.coverageEnabled,
            countries: autocheck.countriesPackageProtection || [],
            pricingRuleSet: autocheck.packageProtection.pricingRuleSets,
          }
        : undefined,

      // Shopify extension settings
      shopifyExtension: {
        disableBusinessAccountInStorefront:
          autocheck.disableBusinessAccountInStorefront,
      },
    },
  };
}
